import { FC } from "react";
import { Box } from "@mui/material";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";

export const thumbUrl = (videoId: string) => `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

interface ThumbnailProps {
  videoId: string;
  isNew?: boolean;
  size?: "hero" | "card";
}

/** Capa do tutorial (thumbnail do YouTube + play). `hero` = 16:9; `card` = 16:10. */
const Thumbnail: FC<ThumbnailProps> = ({ videoId, isNew, size = "card" }) => {
  const isHero = size === "hero";

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        paddingTop: isHero ? "56.25%" : "62.5%",
        borderRadius: isHero ? "14px 14px 0 0" : "12px 12px 0 0",
        overflow: "hidden",
        background: "linear-gradient(135deg, #C9A368 0%, #B68F54 100%)",
        flexShrink: 0,
      }}
    >
      <Box component="img" src={thumbUrl(videoId)} alt="" sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(0,0,0,0.18)",
          transition: "background 0.18s",
          "&:hover": { background: "rgba(0,0,0,0.32)" },
        }}
      >
        <PlayCircleFilledWhiteIcon sx={{ fontSize: isHero ? 64 : 48, color: "rgba(255,255,255,0.88)", filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.4))" }} />
      </Box>

      {isNew && (
        <Box
          sx={{
            position: "absolute",
            top: isHero ? 12 : 10,
            right: isHero ? 12 : 10,
            px: 1,
            py: "2px",
            borderRadius: "6px",
            backgroundColor: "success.main",
            color: "success.contrastText",
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.8px",
            textTransform: "uppercase",
          }}
        >
          Novo
        </Box>
      )}
    </Box>
  );
};

export default Thumbnail;
